import { ICashboxSettings, ICashboxSettingsListItem, CashboxSettingsResponseType } from "./cashboxSettings.types";

export default class Cashbox implements ICashboxSettings {
    total: number;
    data: ICashboxSettingsListItem[] = [];
    constructor(data: CashboxSettingsResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}